import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import Heading from '../Heading';
import Modal from '../Modal';
import ModalActions from '../ModalActions';
import ModalContent from '../ModalContent';
import ModalHeader from '../ModalHeader';
import Text from '../Text';
var Confirmation = function Confirmation(_ref) {
  var cancelBtnText = _ref.cancelBtnText,
    confirmBtnText = _ref.confirmBtnText,
    open = _ref.open,
    cancelling = _ref.cancelling,
    confirming = _ref.confirming,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm,
    message = _ref.message,
    title = _ref.title;
  var content = function content() {
    if (message && typeof message === 'string') {
      return /*#__PURE__*/React.createElement(Text, {
        paragraph: false
      }, message);
    }
    return message;
  };
  return /*#__PURE__*/React.createElement(Modal, {
    escapePress: false,
    maxWidth: "xs",
    "aria-labelledby": "confirmation-dialog-title",
    open: open
  }, title && /*#__PURE__*/React.createElement(ModalHeader, {
    id: "confirmation-dialog-title",
    elevate: false
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h5",
    gutterBottom: false
  }, title)), /*#__PURE__*/React.createElement(ModalContent, null, content()), /*#__PURE__*/React.createElement(ModalActions, {
    elevate: false
  }, onCancel && cancelBtnText && /*#__PURE__*/React.createElement(Button, {
    onClick: onCancel,
    color: "primaryAlt",
    variant: "outlined",
    size: "small",
    loading: true,
    pending: cancelling
  }, cancelBtnText), onConfirm && confirmBtnText && /*#__PURE__*/React.createElement(Button, {
    onClick: onConfirm,
    color: "primary",
    size: "small",
    loading: true,
    pending: confirming
  }, confirmBtnText)));
};
Confirmation.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Text displayed in cancel button
   */
  cancelBtnText: PropTypes.string,
  /**
   * Text displayed in confirm button
   */
  confirmBtnText: PropTypes.string,
  /**
   * If `true`, confirm modal will be visible
   */
  open: PropTypes.bool,
  /**
   * Callback when cancel button is clicked
   */
  onCancel: PropTypes.func.isRequired,
  /**
   * If `true`, will show loader in cancel button
   */
  cancelling: PropTypes.bool,
  /**
   * Callback when confirm button is clicked
   */
  onConfirm: PropTypes.func.isRequired,
  /**
   * If `true`, will show loader in confirm button
   */
  confirming: PropTypes.bool,
  /**
   * Contents of the body
   */
  message: PropTypes.node,
  /**
   * Heading of the modal
   */
  title: PropTypes.string
} : {};
Confirmation.defaultProps = {
  cancelBtnText: 'Cancel',
  confirmBtnText: 'Ok',
  open: false,
  title: 'Are you sure?',
  message: '',
  cancelling: false,
  confirming: false
};
export default Confirmation;